<template>
    <div class="applyList">
        <!-- banner -->
        <div class="banner">
            <div class="img"><img src="@/assets/img/ggu_logo.png" alt=""></div>
            <p>世毕盟本科
                <span>申请部分案例</span>
            </p>
        </div>
        <!-- list -->
        <div class="apply_list">
            <ul class="wrap">
                <li class="apply_li" v-for="(item,index) in applyData" :key="index">
                    <div class="top" :style="'background:'+item.background">
                        <div class="school">
                            <p class="school_name">{{item.e_apply_school}}</p>
                            <p class="enter">{{item.c_apply_school}}</p>
                        </div>
                        <div class="year" v-if="item.admission_year">
                            <span class="iconfont icon-huangguan"></span>
                            {{item.admission_year}}
                        </div>
                        <img :src="dataImgUrl+item.logo" alt="">
                    </div>
                    <div class="bottom">
                        <p class="p_title">{{item.name}}同学 | {{item.school}}</p>
                        <p class="language">{{item.language_achievement}}</p>
                        <div class="info">
                            <span>录取结果</span>
                            <p class="result">{{item.admission_results}}</p>
                        </div>
                    </div>
                </li>
                <div class="loading" v-if="!applyData.length">
                    <van-loading type="spinner" color="#05c9d3" />
                </div>
            </ul>
        </div>
    </div>
</template>

<script>

import api from "@/api/apply";
export default {
    data() {
        return {
            dataImgUrl:"http://www.gguconsulting.com/try/sbm/Public/GGUExper_files/",
            applyData:[],
            wxImg: "http://www.gguconsulting.com/try/sbm/Public/img/ggu_logo.jpg",
        }
    },
    methods:{
        //获取offer数据
        async getApplyData(){
            try {
                let re = await api.apply_undergraduate_list();
                this.applyData = re.data.data.list;
            } catch (error) {
                console.error(error);
            }
        }
    },
    created(){
        this.WXConfig.wxShowMenu("世毕盟本科申请","美英top名校申请专家，让你脱颖而出！","http://www.gguconsulting.com/try/sbm/index.php/#/applylist",this.wxImg);
        this.getApplyData();
    }
}
</script>

<style lang="less" scoped>
.applyList {
    background:#fff;
    // font-family: 'PingFang Regular';
    .banner {
        width: 100%;
        height: 360px;
        position: relative;
        background:url("../../assets/img/applyList_banner.jpg") no-repeat;
        p {
            padding-top: 125px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #FEEA8B;
            }
        }
        .img {
            width: 170px;
            // height: 38px;
            position: absolute;
            top: 40px;
            left: 43px;
            img {
                width: 100%;
                // height: 100%;
            }
        }
    }
    .apply_list{
        padding:0 25px 100px;
        ul {
            margin-top: -115px;
            position: relative;
            li {
                margin-bottom: 30px;
                .top {
                    width: 100%;
                    height: 120px;
                    color: #fff;
                    font-weight: bold;
                    padding-left: 25px;
                    box-sizing: border-box;
                    border-radius:20px 20px 0px 0px;
                    display: flex;
                    overflow: hidden;
                    .school {
                        flex: 1;
                        padding: 25px 0;
                        .school_name {
                            font-size: 26px;
                        }
                        .enter {
                            font-size: 24px;
                            font-style: italic;
                            margin-top: 5px;
                        }
                    }
                    .year{
                        line-height:120px;
                        font-size:28px;
                        margin-right:50px;
                        span{
                            margin-right:5px;
                        }
                    }
                    img {
                        float: right;
                        width: auto;
                        height: 100px;
                        margin:10px 10px 0 0;
                    }
                }
                .bottom {
                    border: 1px solid rgba(204, 204, 204, 1);
                    border-top: none;
                    border-radius: 0 0 20px 20px;
                    padding-top: 40px;
                    text-align: center;
                    .project_ {
                        font-size: 26px;
                        color: #4D4D4D;
                    }
                    .p_title {
                        font-size: 30px;
                        color: #000; 
                        font-weight: bold;
                    }
                    .language {
                        margin-top: 10px;
                        font-size: 26px;
                        color: #666666;
                    }
                    .info {
                        margin-top: 70px;
                        background: #F5F5F5;
                        position: relative;
                        padding:40px 24px;
                        font-size: 28px;
                        color: #020202;
                        text-align: left;
                        line-height:46px;
                        border-radius: 0 0 20px 20px;
                        span {
                            width:166px;
                            height:48px;
                            background:rgba(0,0,0,1);
                            border-radius:24px;
                            position: absolute;
                            top: -24px;
                            left: 50%;
                            transform: translateX(-50%);
                            font-size: 28px;
                            line-height: 48px;
                            text-align: center;
                            background: #000;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
    .loading{
        text-align: center;
        height:200px;
        .van-loading{
            width:100%;
            margin-top:200px;
            color:#000 !important;
        }
    }
}
</style>